import { AscEventName, AscTrackingEvent } from '../interfaces/interface.asc-analytics';
import { TradeInEvent } from '../interfaces/interface.shift-digital-analytics';
import EventBus from '../services/service.eventBus';
import { state as bannerState } from '../store/store.interactive-banner';
import { ACS_EVENT_PROPS, ASC_EVENTS, ASC_TRACKING_EVENT_NAME } from '../utils/utils.asc-analytics';
import { SD_EVENTS, SHIFT_DIGITAL_ANALYTICS_EVENT } from '../utils/utils.shift-digital-analytics';
import { eventProperties } from './tracking.asc';

/* eslint-disable camelcase */
export function sendAscTrackingEvent(eventName: AscEventName, eventProps) {
  const measurementId = getAscMeasurementId(bannerState.groupId, bannerState.cobrandingGroupMeasurementId, bannerState.measurementId);
  if (measurementId) {
    const event = eventProperties(eventName, measurementId, eventProps) as AscTrackingEvent;
    EventBus.publish(ASC_TRACKING_EVENT_NAME, event);
  }
}

export function getAscMeasurementId(cobrandingGroupId: string, cobrandingGroupMeasurementId: string, measurementId: string) {
  return cobrandingGroupId ? cobrandingGroupMeasurementId : measurementId;
}

export const trackBannerLinkClick = (eventProps) => {
  sendAscTrackingEvent(ASC_EVENTS.CTA_INTERACTION, eventProps);
};

export const trackBannerButtonClick = (eventProps) => {
  if (eventProps !== ACS_EVENT_PROPS.VIEW_OFFER_CERTIFICATE) {
    sendAscTrackingEvent(ASC_EVENTS.RETAIL_PROCESS, eventProps);
  }
  sendAscTrackingEvent(ASC_EVENTS.CTA_INTERACTION, eventProps);
};
/* eslint-enable camelcase */

export function sendShiftDigitalAnalyticsEvent(event: TradeInEvent) {
  EventBus.publish(SHIFT_DIGITAL_ANALYTICS_EVENT, event);
}

export const shiftDigitalTradeInStart = () => {
  sendShiftDigitalAnalyticsEvent({
    events: SD_EVENTS.tradeInStart,
  });
};

export const shiftDigitalTradeInVehicleIndicated = () => {
  sendShiftDigitalAnalyticsEvent({
    events: SD_EVENTS.tradeInVehicleIndicated,
    tradeInYear: bannerState.yearId.toString(),
    tradeInMake: bannerState.make,
    tradeInModel: bannerState.model,
  });
};
